<po-page-list
  [p-actions]="pageActions"
  [p-filter]="filter"
  [p-quick-search-value]="searchTerm">
  <po-container class="sr-admin-repositories-container" [p-no-border]="true" [p-no-padding]="true">
    <!-- O carregamento é o da TABELA, e só dela: `loading` é escrito por
         loadRepositories, que busca as linhas.

         Havia também um po-loading-overlay cobrindo este container. Além de duplicar o
         indicador, ele caía no lugar errado: o overlay do PO é `inset: 0` com
         `place-items: center`, então centraliza na altura do container — e com a lista
         vazia o container tem pouco mais que os filtros e o "Nenhum dado encontrado".
         O spinner aparecia colado no topo, junto dos botões, em vez de sobre os dados
         que estão sendo buscados. -->
    <div class="sr-admin-repositories-filters po-row">
      <po-select
        class="po-md-3"
        name="repositoryStatusFilter"
        p-label="Status"
        [p-options]="statusFilterOptions"
        [(ngModel)]="statusFilter"
        (p-change)="onRepositoryFiltersChange()">
      </po-select>
      <po-combo
        class="po-md-4"
        name="repositoryAreaFilter"
        p-label="Área"
        p-placeholder="Todas as áreas"
        p-clean="true"
        p-filter-mode="contains"
        p-sort="true"
        [p-options]="areaOptions"
        [(ngModel)]="areaFilter"
        (ngModelChange)="onRepositoryFiltersChange()">
      </po-combo>
    </div>

    <po-table
      [p-columns]="columns"
      [p-items]="rows"
      [p-actions]="tableActions"
      p-actions-right="true"
      p-striped="true"
      p-spacing="small"
      p-hide-columns-manager="true"
      [p-loading]="loading"
      [p-show-more-disabled]="allLoaded"
      [p-loading-show-more]="loadingShowMore"
      (p-show-more)="onShowMore()">
      <ng-template p-table-cell-template let-column="column" let-row="row">
        <ng-container *ngIf="column.property === 'statusLabel'">
          <po-tag [p-value]="row.statusLabel" [p-type]="row.statusType" p-inverse="true"></po-tag>
        </ng-container>
      </ng-template>
    </po-table>
  </po-container>

  <po-modal
    #repositoryModal
    [p-title]="modalTitle"
    p-size="lg"
    p-click-out="false"
    [p-primary-action]="saveAction"
    [p-secondary-action]="cancelAction">

    <po-divider p-label="Origem"></po-divider>

    <div class="po-row">
      <!-- Seleção quando a lista carregou; campo livre quando não. Um select vazio por
           falha ao listar provedores travaria o cadastro por inteiro. -->
      <po-select
        *ngIf="providerOptions.length > 0"
        class="po-md-4"
        name="repoProvider"
        p-label="Provedor"
        [p-options]="providerOptions"
        [p-disabled]="editingMode"
        [p-required]="true"
        [ngModel]="form.provider"
        (ngModelChange)="onProviderChange($event)">
      </po-select>
      <po-input
        *ngIf="providerOptions.length === 0"
        class="po-md-4"
        name="repoProviderFree"
        p-label="Provedor"
        p-placeholder="gitea"
        [p-disabled]="editingMode"
        [p-required]="true"
        [ngModel]="form.provider"
        (ngModelChange)="onProviderChange($event)">
      </po-input>
    </div>

    <!-- O cadastro tem UM fluxo, igual em todo provedor: cole o endereço ou digite as
         coordenadas. Onde o provedor sabe listar, a busca entra como ATALHO — antes ela
         era o único caminho, e quando a listagem falhava não havia como cadastrar.
         Editar é outra história: a origem não se mexe, porque trocá-la apontaria o
         cadastro para outro repositório e os reviews já gravados referenciariam código
         que não é deles. -->
    <!-- po-url e não po-input: a validação de endereço é do componente, e o rótulo
         "Endereço" já diz o que ele aceita. A frase "Atalho: preenche org e nome" existia
         para explicar a relação com os campos abaixo — que agora vivem recolhidos, e o
         acordeão fechado diz o mesmo sem ocupar linha. -->
    <div class="po-row" *ngIf="!editingMode && showOriginFields">
      <po-url
        class="po-md-12"
        name="repoUrl"
        p-label="Endereço do repositório"
        [p-placeholder]="repositoryUrlPlaceholder"
        [p-pattern]="repositoryUrlPattern"
        p-clean="true"
        p-optional="true"
        [ngModel]="repositoryUrl"
        (ngModelChange)="onRepositoryUrlChange($event)">
      </po-url>
    </div>

    <!-- A etapa de projeto existe onde ela paga por si.
         Não é exigência da API — buscar sem projeto funciona. É custo: no Azure DevOps o
         adaptador lista os projetos, resolve o descritor de grupo de CADA UM e então lista
         os repositórios de cada projeto acessível, sem cache. Numa organização de 40
         projetos são ~58 chamadas por busca, contra 4 com o projeto escolhido.

         No Gitea a mesma busca custa de 1 a 3 chamadas, constante, e o próprio campo
         resolve `dono/` listando tudo daquele dono: lá a etapa não teria o que pagar, e
         não aparece.

         É po-combo, e não po-lookup: o lookup abre a busca num po-modal PRÓPRIO, e este
         campo vive dentro do po-modal do cadastro — dois modais empilhados disputam o
         mesmo overlay e a tela trava. -->
    <div class="po-row" *ngIf="!editingMode && showOriginFields && canSearchRemoteRepos">
      <po-combo
        *ngIf="selectedProviderProjectScoped"
        class="po-md-6"
        name="repoRemoteProject"
        p-label="Buscar projeto"
        p-placeholder="Digite para filtrar os projetos"
        p-clean="true"
        p-optional="true"
        [p-filter-service]="remoteProjectComboFilterService"
        [p-debounce-time]="400"
        [p-filter-minlength]="0"
        [ngModel]="selectedRemoteProject"
        (ngModelChange)="onRemoteProjectSelected($event)">
      </po-combo>

      <po-combo
        [class]="selectedProviderProjectScoped ? 'po-md-6' : 'po-md-12'"
        name="repoRemoteRepo"
        p-label="Buscar repositório"
        [p-placeholder]="remoteRepoPlaceholder"
        p-clean="true"
        p-optional="true"
        [p-filter-service]="remoteRepoSearchService"
        [p-debounce-time]="400"
        [p-filter-minlength]="selectedProviderProjectScoped ? 2 : 0"
        [p-disabled]="remoteRepoLookupDisabled"
        [ngModel]="selectedRemoteRepo"
        (ngModelChange)="onRemoteRepoSelected($event)">
      </po-combo>
    </div>

    <!-- Falha de listagem é ALERTA, e não informação: po-info a exibiria como um campo
         qualquer, sem o papel de alerta para o leitor de tela e sem a cor que a distingue
         de um rótulo. É um só desde que a busca virou um campo: antes havia um para a
         listagem de projetos e outro para a de repositórios. -->
    <div *ngIf="remoteLookupError" class="sr-repository-hint sr-repository-hint-warn" role="alert">
      <span class="po-icon po-icon-warning" aria-hidden="true"></span>
      <span>{{ remoteLookupError }}</span>
    </div>

    <!-- As coordenadas recolhidas.
         Elas são o DESTINO do endereço e da busca, não um terceiro caminho concorrente:
         abertas, somavam três campos à primeira dobra para repetir o que os outros dois
         já preenchem. Fechadas, continuam ao alcance de quem precisa corrigir o que o
         endereço leu errado ou cadastrar sem ter a URL à mão. -->
    <po-accordion *ngIf="!editingMode && showOriginFields">
      <po-accordion-item p-label="Informar manualmente">
        <div class="po-row">
          <!-- Obrigatórios porque o servidor os exige, e o rótulo tem de dizer isso antes
               do Salvar. Marcá-los como opcionais e recusar depois é a tela contradizendo
               a si mesma no pior momento: com tudo preenchido. -->
          <po-input
            [class]="selectedProviderProjectScoped ? 'po-md-4' : 'po-md-6'"
            name="repoOrg"
            p-label="Org"
            p-required="true"
            [(ngModel)]="form.org">
          </po-input>
          <po-input
            class="po-md-4"
            name="repoProject"
            p-label="Projeto"
            *ngIf="selectedProviderProjectScoped"
            p-required="true"
            [(ngModel)]="form.project">
          </po-input>
          <po-input
            [class]="selectedProviderProjectScoped ? 'po-md-4' : 'po-md-6'"
            name="repoName"
            p-label="Nome"
            p-required="true"
            [(ngModel)]="form.name">
          </po-input>
        </div>
      </po-accordion-item>
    </po-accordion>

    <ng-container *ngIf="hasRepositoryIdentity">
      <po-divider p-label="Configuração"></po-divider>
      <div class="po-row">
        <po-input
          class="po-md-6"
          name="repoDefaultBranch"
          p-label="Branch padrão"
          p-placeholder="main"
          p-optional="true"
          [(ngModel)]="form.defaultBranch">
        </po-input>
      </div>

      <po-divider p-label="Política"></po-divider>
      <div class="po-row">
        <po-combo
          class="po-md-12"
          name="repoAreaId"
          p-label="Área"
          p-placeholder="Todas as áreas"
          p-clean
          p-filter-mode="contains"
          p-sort
          [p-options]="areaOptions"
          [(ngModel)]="form.areaId">
        </po-combo>
        <po-switch
          *ngIf="editingMode"
          class="po-md-6 sr-repository-enabled"
          name="repoEnabled"
          p-label="Status"
          p-label-on="Habilitado"
          p-label-off="Desabilitado"
          [p-value]="form.enabled"
          (p-change)="form.enabled = $event">
        </po-switch>
      </div>
    </ng-container>
  </po-modal>

  <po-modal
    #deleteModal
    [p-title]="deleteTitle"
    p-size="sm"
    p-click-out="false"
    [p-primary-action]="deletePrimaryAction"
    [p-secondary-action]="deleteSecondaryAction">
    <p *ngIf="pendingDelete">O cadastro {{ pendingDelete.fullName }} será removido.</p>
  </po-modal>
</po-page-list>

<notificationComponentHM></notificationComponentHM>
